













































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import DataPenunjang from "@/services/DataPenunjang";
import LabTrenChart from "@/components/chart/LabTrenChart.vue";
import {
  MAKS_GRAFIK_LAB,
  PALET_SERI_LAB,
  LabSampelTren,
  OpsiPemeriksaan,
  Rujukan,
  SeriTren,
  StatusTitik,
  TitikTren,
  aturSlotWarna,
  bangunSeri,
  formatAngka,
  formatWaktu,
  gabungOpsi,
  isFlagAbnormal,
  opsiPemeriksaan,
  statusTitik,
  teksTren,
  titikNumerik,
  titikTerakhir
} from "@/utils/labTren";

interface GrafikSeri {
  seri: SeriTren;
  warna: string;
  numerik: TitikTren[];
  urutTerbaru: TitikTren[];
  terakhir: TitikTren | null;
  status: StatusTitik | null;
  rujukanTeks: string;
  rujukan: Rujukan | null;
  tren: string;
  chartData: any;
  options: any;
}

interface FilterTampil {
  kunci: string[];
  dari: string;
  sampai: string;
}

const WARNA_ABNORMAL = "#d03b3b";
const WARNA_RUJUKAN = "rgba(12, 163, 12, 0.55)";
const ISI_RUJUKAN = "rgba(12, 163, 12, 0.10)";
const WARNA_GRID = "#e1e0d9";
const WARNA_SUMBU = "#c3c2b7";
const WARNA_TEKS_SUMBU = "#898781";

@Component({ components: { LabTrenChart } })
export default class LabTrenGrafikDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ required: true }) readonly rm!: string;
  @Prop({ type: Array, default: () => [] })
  readonly pemeriksaanAwal!: string[];
  @Prop({ type: String, default: "" }) readonly dariAwal!: string;
  @Prop({ type: String, default: "" }) readonly sampaiAwal!: string;
  @Prop({ type: Array, default: () => [] })
  readonly opsiAwal!: OpsiPemeriksaan[];

  maks = MAKS_GRAFIK_LAB;
  today = moment().format("YYYY-MM-DD");
  pilihan: string[] = [];
  dari = "";
  sampai = "";
  menuDari = false;
  menuSampai = false;
  terpotong = false;
  loading = false;
  galat = "";
  sampel: LabSampelTren[] = [];
  opsiTerkumpul: OpsiPemeriksaan[] = [];
  ditampilkan: FilterTampil | null = null;
  slotWarna: { [kunci: string]: number } = {};
  zoomKunci = "";
  tabelKunci: { [kunci: string]: boolean } = {};
  nomorPermintaan = 0;

  isFlagAbnormal = isFlagAbnormal;
  formatWaktu = formatWaktu;

  @Watch("value", { immediate: true })
  onValue(buka: boolean) {
    if (buka) this.mulai();
  }

  @Watch("pilihan")
  onPilihan() {
    this.sinkronWarna();
  }

  mulai() {
    const awal = (this.pemeriksaanAwal || []).filter(k => !!k);
    this.pilihan = awal.slice(0, this.maks);
    this.terpotong = awal.length > this.maks;
    this.sampai = this.sampaiAwal || this.today;
    this.dari =
      this.dariAwal ||
      moment(this.sampai, "YYYY-MM-DD")
        .subtract(1, "month")
        .format("YYYY-MM-DD");
    if (this.dari > this.sampai) this.dari = this.sampai;
    this.sampel = [];
    this.opsiTerkumpul = [];
    this.ditampilkan = null;
    this.galat = "";
    this.zoomKunci = "";
    this.tabelKunci = {};
    this.slotWarna = {};
    this.sinkronWarna();
    if (this.pilihan.length) this.tampilkan();
  }

  get opsiDialog() {
    const penuh = this.pilihan.length >= this.maks;
    return gabungOpsi(
      opsiPemeriksaan(this.sampel),
      this.opsiAwal,
      this.opsiTerkumpul
    ).map(o => ({
      text: o.text,
      value: o.value,
      disabled: penuh && this.pilihan.indexOf(o.value) === -1
    }));
  }

  get filterBerubah(): boolean {
    const t = this.ditampilkan;
    if (!t) return false;
    return (
      t.dari !== this.dari ||
      t.sampai !== this.sampai ||
      t.kunci.join("|") !== this.pilihan.join("|")
    );
  }

  get grafikTampil(): GrafikSeri[] {
    if (!this.ditampilkan) return [];
    return bangunSeri(this.sampel, this.ditampilkan.kunci).map(seri =>
      this.bangunGrafik(seri)
    );
  }

  batasiPilihan(nilai: string[]) {
    if ((nilai || []).length > this.maks) {
      this.pilihan = nilai.slice(0, this.maks);
    }
  }

  hapusPilihan(kunci: string) {
    this.pilihan = this.pilihan.filter(k => k !== kunci);
  }

  sinkronWarna() {
    const dipakai = this.pilihan.slice();
    if (this.ditampilkan) {
      this.ditampilkan.kunci.forEach(k => {
        if (dipakai.indexOf(k) === -1) dipakai.push(k);
      });
    }
    const baru = aturSlotWarna(this.slotWarna, dipakai);
    const sama =
      Object.keys(baru).length === Object.keys(this.slotWarna).length &&
      Object.keys(baru).every(k => this.slotWarna[k] === baru[k]);
    if (!sama) this.slotWarna = baru;
  }

  warnaSeri(kunci: string): string {
    const slot = this.slotWarna[kunci];
    return PALET_SERI_LAB[slot === undefined ? 0 : slot];
  }

  tampilkan() {
    if (!this.rm || !this.pilihan.length || !this.dari || !this.sampai) return;
    const filter: FilterTampil = {
      kunci: this.pilihan.slice(0, this.maks),
      dari: this.dari,
      sampai: this.sampai
    };
    const nomor = ++this.nomorPermintaan;
    this.loading = true;
    this.galat = "";
    DataPenunjang.getDataRiwayatLab(this.rm, filter.dari, filter.sampai)
      .then((res: any) => {
        if (nomor !== this.nomorPermintaan) return;
        if (!res || !Array.isArray(res.data)) {
          this.galat = "Riwayat hasil lab gagal dimuat. Coba lagi.";
          return;
        }
        this.sampel = res.data;
        this.opsiTerkumpul = gabungOpsi(
          opsiPemeriksaan(this.sampel),
          this.opsiTerkumpul
        );
        this.ditampilkan = filter;
        this.zoomKunci = "";
        this.tabelKunci = {};
        this.sinkronWarna();
      })
      .finally(() => {
        if (nomor === this.nomorPermintaan) this.loading = false;
      });
  }

  bangunGrafik(seri: SeriTren): GrafikSeri {
    const warna = this.warnaSeri(seri.kunci);
    const numerik = titikNumerik(seri);
    const terakhir = titikTerakhir(seri);
    const acuan = numerik.length ? numerik[numerik.length - 1] : terakhir;
    const rujukan = acuan ? acuan.rujukan : null;
    const rujukanTeks = acuan ? acuan.rujukanTeks : "";
    const satuan = seri.satuan ? " " + seri.satuan : "";

    const datasets = [
      {
        label: seri.nama,
        data: numerik.map(t => t.nilai),
        borderColor: warna,
        backgroundColor: warna,
        borderWidth: 2,
        lineTension: 0,
        fill: false,
        pointStyle: numerik.map(t =>
          isFlagAbnormal(t.flag) ? "triangle" : "circle"
        ),
        pointRadius: numerik.map(t => (isFlagAbnormal(t.flag) ? 6 : 4)),
        pointHoverRadius: numerik.map(t => (isFlagAbnormal(t.flag) ? 8 : 6)),
        pointHitRadius: 12,
        pointBackgroundColor: numerik.map(t =>
          isFlagAbnormal(t.flag) ? WARNA_ABNORMAL : warna
        ),
        pointBorderColor: "#ffffff",
        pointBorderWidth: 2
      }
    ];

    const nilai = numerik.map(t => t.nilai as number);
    if (rujukan && rujukan.low !== null) nilai.push(rujukan.low);
    if (rujukan && rujukan.high !== null) nilai.push(rujukan.high);
    const minY = nilai.length ? Math.min(...nilai) : 0;
    const maxY = nilai.length ? Math.max(...nilai) : 1;
    const jeda = (maxY - minY) * 0.08 || Math.abs(maxY) * 0.1 || 1;

    const chartData = {
      labels: numerik.map(t => [
        formatWaktu(t.waktu, "DD/MM/YY"),
        formatWaktu(t.waktu, "HH:mm")
      ]),
      datasets
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      animation: { duration: 0 },
      hover: { mode: "index", intersect: false, animationDuration: 0 },
      responsiveAnimationDuration: 0,
      legend: { display: false },
      layout: { padding: { top: 8, right: 12, bottom: 0, left: 4 } },
      rujukanLab: rujukan
        ? {
            low: rujukan.low,
            high: rujukan.high,
            isi: ISI_RUJUKAN,
            garis: WARNA_RUJUKAN
          }
        : null,
      scales: {
        xAxes: [
          {
            offset: true,
            gridLines: {
              color: WARNA_GRID,
              zeroLineColor: WARNA_SUMBU,
              drawTicks: false
            },
            ticks: {
              fontColor: WARNA_TEKS_SUMBU,
              fontSize: 11,
              padding: 6,
              maxRotation: 0,
              autoSkip: true,
              autoSkipPadding: 12
            }
          }
        ],
        yAxes: [
          {
            gridLines: {
              color: WARNA_GRID,
              zeroLineColor: WARNA_SUMBU,
              drawTicks: false
            },
            ticks: {
              fontColor: WARNA_TEKS_SUMBU,
              fontSize: 11,
              padding: 6,
              maxTicksLimit: 6,
              suggestedMin: minY >= 0 ? Math.max(0, minY - jeda) : minY - jeda,
              suggestedMax: maxY + jeda,
              callback: (v: number) => formatAngka(v)
            }
          }
        ]
      },
      tooltips: {
        mode: "index",
        intersect: false,
        filter: (item: any) => item.datasetIndex === 0,
        callbacks: {
          title: (items: any[]) => {
            const t = items.length ? numerik[items[0].index] : null;
            return t ? formatWaktu(t.waktu) : "";
          },
          label: (item: any) => {
            const t = numerik[item.index];
            if (!t) return "";
            const s = statusTitik(t);
            return `${t.hasilTeks}${satuan}${s ? " (" + s.teks + ")" : ""}`;
          },
          afterLabel: (item: any) => {
            const t = numerik[item.index];
            if (!t) return "";
            const baris = [`Rujukan: ${t.rujukanTeks || "-"}`];
            if (t.unit) baris.push(`Unit: ${t.unit}`);
            baris.push(`Sampel: ${t.lisSampel}`);
            return baris;
          }
        }
      }
    };

    return {
      seri,
      warna,
      numerik,
      urutTerbaru: seri.titik.slice().reverse(),
      terakhir,
      status: statusTitik(terakhir),
      rujukanTeks,
      rujukan,
      tren: teksTren(seri),
      chartData,
      options
    };
  }

  toggleZoom(kunci: string) {
    this.zoomKunci = this.zoomKunci === kunci ? "" : kunci;
  }

  toggleTabel(kunci: string) {
    this.tabelKunci = { ...this.tabelKunci, [kunci]: !this.tabelKunci[kunci] };
  }

  formatTanggal(tgl: string): string {
    return formatWaktu(tgl, "DD-MM-YYYY");
  }

  tutup() {
    this.$emit("input", false);
  }
}
